import SliderImageSeparator from "./common/SliderImageSeparator"
import ImageSectionItem from "./common/ImageSectionItem"
import IconTextSection from "./common/IconTextSection"
import ImageTitleItem from "./common/ImageTitleItem"
import SeparatorLine from "./common/SeparatorLine"
import { Link } from "react-router-dom"
import "./Publications.css"
import { useEffect } from "react"

const Publications = () => {

    useEffect(() => {
        document.title = 'Séneca - Departamento Publicaciones'
        window.scrollTo(0, 0)
    }, [])

    return (
        <main className="publications-main">

            <ImageTitleItem
                imageURL="/images/publications/publicaciones-1.jpg"
                titleText="Del debate al acta oficial, sin fricciones"
                icon="bi bi-pen-fill blue-icon"
                subtitleText="Séneca centraliza todo el flujo de trabajo del departamento: transcripción distribuida, control de tareas, creación del diario de sesiones y firma digital del vídeo-acta."
            />

            <SliderImageSeparator />

            <ImageSectionItem
                imagePosition="before"
                layout="row"
                imageURL="/images/publications/publicaciones-2.jpg"
                title="Vídeo-acta con validez legal"
                textArray={[
                    "<p class='middle-section-label'><strong>Séneca garantiza la autenticidad e integridad del vídeo-acta mediante la firma del Secretario con certificado digital o DNI electrónico, y su posterior validación pública.</strong></p>",
                    "<p class='middle-section-label'>Vídeo y acta quedan unidos en un único documento (.pdf), inseparable e inalterable, listo para ser archivado y consultado con total transparencia.</p>"
                ]}
                modern="true"
            />

            <SeparatorLine />

            <ImageSectionItem
                imagePosition="after"
                layout="column"
                imageURL="/images/publications/publicaciones-3.jpg"
                title="Transcripción: para un equipo de uno o de cien"
                textArray={[
                    "<p class='middle-section-label'><strong>Tanto para un único transcriptor como para grandes equipos, Séneca distribuye las tareas desde el inicio de la sesión y mantiene el control completo del trabajo.</strong></p>",
                    "<p class='middle-section-label'>El sistema gestiona distintos roles en el proceso: transcriptor, corrector, supervisor y administrador. El responsable del servicio puede consultar el estado y el progreso de cada fragmento y de cada transcriptor en tiempo real.</p>",
                    "<p class='middle-section-label'>La herramienta de transcripción automática de Séneca genera un borrador de texto del vídeo que el transcriptor puede revisar y corregir escuchando el audio de la sesión.</p>"
                ]}
                isBigImage="true"
                imageClassName="tall-diagram-image"
            />

            <SeparatorLine />

            <IconTextSection
                imageURL="/images/publications/publicaciones-5.png"
                title="Trabajo remoto y servicio externo"
                textArray={[
                    "<p class='middle-section-label'><strong>Séneca funciona íntegramente en web: el equipo puede acceder al puesto de trabajo desde la red interna o desde cualquier lugar con conexión a internet.</strong></p>",
                    "<p class='middle-section-label'>Cuando el volumen de trabajo lo requiera, es posible externalizar la transcripción a un servicio externo y recibir las sesiones transcritas en los plazos acordados, con el seguimiento del encargo integrado en la misma plataforma.</p>",
                    "<p class='middle-section-label'>También pueden contratarse servicios adicionales como subtitulación, traducción o vinculación del texto al instante exacto del vídeo.</p>"
                ]}
            />

            <section className="main-cta-section">
                <h2 className="main-cta-title">¿Quieres verlo en funcionamiento?</h2>
                <p className="main-cta-desc">Cuéntanos cómo trabaja tu departamento y te mostramos cómo Séneca puede adaptarse a vuestro flujo de trabajo.</p>
                <Link to="/contacto" className="main-cta-button">Solicitar una demo</Link>
            </section>

        </main>
    )

}

export default Publications
